<template>
  <div class="all_part">
    <div>
      <titleBlock_computer></titleBlock_computer>   
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
         
            <el-input
              v-model="client"
              placeholder="客户"
              class="inputs"
            ></el-input>
         
            <el-input
              v-model="business"
              placeholder="业务员"
              class="inputs"
            ></el-input>
          
            <el-date-picker
              v-model="add_time"
              type="date"
              class="inputs"
              value-format="yyyy-MM-dd"
              placeholder="建立日期">
            </el-date-picker>
          
            <el-input
              v-model="order_no"
              placeholder="订单号"
              class="inputs"
            ></el-input>
        
            <el-input
              v-model="client_order_no"
              placeholder="客户订单号"
              class="inputs"
            ></el-input>
       
            <el-input
              v-model="newItemNo"
              placeholder="新料号"
              class="inputs"
            ></el-input>
       
            <el-input
              v-model="clientNewItemNo"
              placeholder="客户料号"
              class="inputs"
            ></el-input>
        
            <el-input
              v-model="oldMaterialNo"
              placeholder="旧料号"
              class="inputs"
            ></el-input>
           
            <el-date-picker
              v-model="arrival_date_json"
              type="date"
              class="inputs"
              value-format="yyyy-MM-dd"
              placeholder="需求到货日期">
            </el-date-picker>
           
            <el-date-picker
              v-model="arrive_date_json"
              type="date"
              class="inputs"
              value-format="yyyy-MM-dd"
              placeholder="到货日期">
            </el-date-picker>
        
            <el-input
              v-model="purchase_no"
              placeholder="采购订单号"
              class="inputs"
            ></el-input>
        
             <el-select v-model="order_status" placeholder="下单状态" class="inputs">
              <el-option
                v-for="(item,index) in statuslist"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          <div class="submit_button">
            <div class="search_buttons">
              <div class="sousuoButton">
                <el-button
                  type="primary"
                  @click="serchFinanceinfo"
                  style="
                    height: 48px;
                    width: 144px;
                    margin-left: 20px;
                    font-size: 16px;
                  "
                  >搜索
                </el-button>
                <div class="icon_sou">
                  <img src="../assets/SouSuo.png" alt="" width="14px" />
                </div>
              </div>
            </div>

            <div class="all_second_button">
              <div class="ChongZhi">
                <div class="second_button" @click="clearInput">
                  <el-button
                    plain
                    type="primary"
                    style="width: 92px; height: 48px; font-size: 16px"
                    >重置
                  </el-button>
                </div>
                <div class="icon_chong">
                  <img src="../assets/ChongZhi.png" alt="" width="14px" />
                </div>
              </div>
              <div class="second_button" @click="clearInput">
                <div class="Fanhu">
                  <div>
                    <el-button
                      plain
                      type="primary"
                      style="width: 92px; height: 48px"
                      @click="back_menu"
                      >返回
                    </el-button>
                  </div>
                  <div class="icon_fan">
                    <img src="../assets/FanHui.png" alt="" width="14px" />
                  </div>
                </div>
              </div>

              <div>
                <!-- <download-excel
                  class="export-excel-wrapper"
                  :data="export_data"
                  :fields="fields"
                  name="销售订单.xls"
                > -->
                  <el-button  
                      type="warning"
                      @click="exportOrderExcel()"
                      style="width: 92px; height: 48px">导出订单</el-button>
                <!-- </download-excel> -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table" style="width: 1920px; overflow:auto;padding:0 20px 0 20px;box-sizing: border-box;">
      <div style="width:100%;">
        <el-table
          border
          ref="filterTable"
          :data="tableData.data"
          style="width: 100%;margin:0 auto;"
          height="100%"
          :row-style="{ height: '70px' }"
        >
          <el-table-column fixed label="编号" width="50" type="index">
          </el-table-column>
          <el-table-column prop="add_time" label="建立日期" width="120"
            column-key="add_time"
            :filters="add_time_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="client" label="客户" width="290"
            column-key="client"
            :filters="client_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="business_name" label="业务人员" width="120"
            column-key="business_name"
            :filters="business_name_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="order_no" label="订单号" width="200"
             column-key="order_no"
            :filters="order_no_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="client_order_no" label="客户订单号" width="200"
             column-key="client_order_no"
            :filters="client_order_no_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="newItemNo" label="新料号" width="200"
             column-key="newItemNo"
            :filters="newItemNo_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="clientNewItemNo" label="客户料号" width="200"
             column-key="clientNewItemNo"
            :filters="clientNewItemNo_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="oldMaterialNo" label="旧料号" width="200"
             column-key="oldMaterialNo"
            :filters="oldMaterialNo_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="num" label="订单数量" width="120"
             column-key="num"
            :filters="num_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="arrival_date" label="需求到货日期" width="120"
             column-key="arrival_date"
            :filters="arrival_date_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="arrive_date" label="到货日期" width="120"
             column-key="arrive_date"
            :filters="arrive_date_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="purchase_no" label="采购订单号" width="200"
             column-key="purchase_no"
            :filters="purchase_no_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="order_status" label="下单状态" width="100"
             column-key="order_status"
            :filters="stock_status_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="delivery_cycle_address" label="交货地" width="220"
             column-key="delivery_cycle_address"
            :filters="delivery_cycle_address_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="direct_no" label="直发运单号码" width="200"
             column-key="direct_no"
            :filters="direct_no_arr"
            :filter-method="filterHandler"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="block">
      <el-pagination
        background
        :page-size="10"
        :page-sizes="[10, 15, 20, 50, 100]"
        layout="sizes, prev, pager, next"
        :total="tableData.total"
        :hide-on-single-page="false"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import JsonExcel from "vue-json-excel";
import { httpUrl } from "../components/publics";
import titleBlock_computer from "../views/titleBlock_computer.vue";
export default {
  data() {
    return {
      PanDuanShou: false,
      pageStats: "",
      tableData: [],
      company_Code: "",
      document_date: "",
      page: "",
      limit: 10,
      //生成筛选项
      add_time_arr: [],
      client_arr: [],
      business_name_arr: [],
      order_no_arr: [],
      client_order_no_arr: [],
      newItemNo_arr: [],
      clientNewItemNo_arr: [],
      oldMaterialNo_arr: [],
      num_arr: [],
      arrival_date_arr: [],
      arrive_date_arr: [],
      purchase_no_arr: [],
      stock_status_arr: [],
      delivery_cycle_address_arr: [],
      direct_no_arr: [],
      export_data: [],
      fields: {
        建立日期: "add_time",
        客户: "client",
        业务人员: "business_name",
        订单号: "order_no",
        客户订单号: "client_order_no",
        新料号: "newItemNo",
        客户新料号: "clientNewItemNo",
        旧料号: "oldMaterialNo",
        订单数量: "num",
        需求到货日期: "arrival_date",
        到货日期: "arrive_date",
        采购单号: "purchase_no",
        状态: "order_status",
        交货地: "delivery_cycle_address",
        直发运单号: "direct_no",
      },
      //搜索关键词
      add_time: '',
      business: "",
      client: '',
      order_no: '',
      client_order_no: '',
      newItemNo: '',
      clientNewItemNo: '',
      oldMaterialNo: '',
      arrival_date_json: '',
      arrive_date_json: '',
      purchase_no: '',
      order_status: '',
      keyword: '',
      statuslist: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      //导出属性
      downloadLoading: false,
    };
  },
  mounted() {
    this.getOrderStatus();
    this.serchFinanceinfo();
  },
  components: {
    titleBlock_computer,
    "download-excel": JsonExcel,
  },
  methods: {
    //导出订单
    exportOrderExcel() {
      let user = JSON.parse(sessionStorage.getItem('user'));

       this.axios
        .get(httpUrl + `/api/index/excelOrder?keyword=${this.keyword}&business=${this.business}&page=${this.page}&limit=10000&user_id=${user.id}&add_time=${this.add_time}&client=${this.client}&order_no=${this.order_no}&client_order_no=${this.client_order_no}
            &newItemNo=${this.newItemNo}&clientNewItemNo=${this.clientNewItemNo}&oldMaterialNo=${this.oldMaterialNo}&arrival_date_json=${this.arrival_date_json}&arrive_date_json=${this.arrive_date_json}&purchase_no=${this.purchase_no}&order_status=${this.order_status}`)
        .then((response) => {
          // if (response.data.code == 200) {
            var aa = httpUrl +
              `/api/index/excelOrder?keyword=${this.keyword}&business=${this.business}&page=${this.page}&limit=10000&user_id=${user.id}&add_time=${this.add_time}&client=${this.client}&order_no=${this.order_no}&client_order_no=${this.client_order_no}
            &newItemNo=${this.newItemNo}&clientNewItemNo=${this.clientNewItemNo}&oldMaterialNo=${this.oldMaterialNo}&arrival_date_json=${this.arrival_date_json}&arrive_date_json=${this.arrive_date_json}&purchase_no=${this.purchase_no}&order_status=${this.order_status}`
            // console.log("888",aa)
            window.location.href = aa;
            
          // }
        })
        .catch((error) => console.log(error, "error"));
    },
    //获取订单状态
    getOrderStatus() {
      this.axios
        .get(
          httpUrl +
            `/api/index/getOrderStatus`
        )
        .then((response) => {
          if (response.data.code == 200) {
            var result = response.data.data;
            var arr = [];
            result.forEach((v,k) => {
              if(v.name !== 'CLOSED' && v.name !== '已取消') {
                arr.push(v);
              }
            })

            this.statuslist = arr;
            console.log('888',arr)
          }else {
            console.log('没有数据');
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    // 导出订单
    exportOrder() {
      let user = JSON.parse(sessionStorage.getItem('user'));
    //  ${user.id}
      this.axios
        .get(
          httpUrl +
            `/api/index/orderList?keyword=${this.keyword}&business=${this.business}&page=${this.page}&limit=10000&user_id=${user.id}&add_time=${this.add_time}&client=${this.client}&order_no=${this.order_no}&client_order_no=${this.client_order_no}
            &newItemNo=${this.newItemNo}&clientNewItemNo=${this.clientNewItemNo}&oldMaterialNo=${this.oldMaterialNo}&arrival_date_json=${this.arrival_date_json}&arrive_date_json=${this.arrive_date_json}&purchase_no=${this.purchase_no}&order_status=${this.order_status}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            var result = response.data.data.data;
             if (result.length === 0) {
                console.log('没有数据');
              } else {
                this.export_data = result;
              }
          }else {
            console.log('没有数据');
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    // 新增筛选
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    back_menu() {
      this.$router.push("/Main_menuComputer");
    },
    inputShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    clearInput() {
      this.keyword = "";
      this.business = "";
      this.add_time = "";
      this.client = "";
      this.order_no = "";
      this.client_order_no = "";
      this.newItemNo = "";
      this.clientNewItemNo = "";
      this.oldMaterialNo = "";
      this.arrival_date_json = "";
      this.arrive_date_json = "";
      this.purchase_no = "";
      this.order_status = "";
      this.$refs.filterTable.clearFilter();
      this.serchFinanceinfo();
    },
    handleCurrentChange(val) {
      // console.log('handleCurrentChange',val)
      this.page = val;
      this.serchFinanceinfo();
    },
    handleSizeChange(e) {
      // console.log('handleSizeChange',e)
      this.limit = e;
      this.serchFinanceinfo();
    },
    serchFinanceinfo() {
      //执行导出
      this.exportOrder();

      let user = JSON.parse(sessionStorage.getItem('user'));
      this.axios
        .get(
          httpUrl +
            `/api/index/orderList?keyword=${this.keyword}&business=${this.business}&page=${this.page}&limit=${this.limit}&user_id=${user.id}&add_time=${this.add_time}&client=${this.client}&order_no=${this.order_no}&client_order_no=${this.client_order_no}
            &newItemNo=${this.newItemNo}&clientNewItemNo=${this.clientNewItemNo}&oldMaterialNo=${this.oldMaterialNo}&arrival_date_json=${this.arrival_date_json}&arrive_date_json=${this.arrive_date_json}&purchase_no=${this.purchase_no}&order_status=${this.order_status}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.tableData = response.data.data;
            console.log('111',this.tableData)
           
            var tableArr = response.data.data.data;
            //对数据处理
            var add_time_arr = [],client_arr = [];
            tableArr.forEach((items, index) => {
              //处理建立日期
              if (this.add_time_arr.findIndex(item => item.value === items.add_time) === -1) {
                var temp = {
                  text: items.add_time,
                  value: items.add_time
                }
                this.$set(this.add_time_arr, this.add_time_arr.length, temp);
              }
              //处理客户
              if (this.client_arr.findIndex(item => item.value === items.client) === -1) {
                var temp = {
                  text: items.client,
                  value: items.client
                }
                this.$set(this.client_arr, this.client_arr.length, temp);
              }
              //处理业务人员
              if (this.business_name_arr.findIndex(item => item.value === items.business_name) === -1) {
                var temp = {
                  text: items.business_name,
                  value: items.business_name
                }
                this.$set(this.business_name_arr, this.business_name_arr.length, temp);
              }
              //处理订单号
              if (this.order_no_arr.findIndex(item => item.value === items.order_no) === -1) {
                var temp = {
                  text: items.order_no,
                  value: items.order_no
                }
                this.$set(this.order_no_arr, this.order_no_arr.length, temp);
              }
              //处理客户订单号
              if (this.client_order_no_arr.findIndex(item => item.value === items.client_order_no) === -1) {
                var temp = {
                  text: items.client_order_no,
                  value: items.client_order_no
                }
                this.$set(this.client_order_no_arr, this.client_order_no_arr.length, temp);
              }
              //处理新料号
              if (this.newItemNo_arr.findIndex(item => item.value === items.newItemNo) === -1) {
                var temp = {
                  text: items.newItemNo,
                  value: items.newItemNo
                }
                this.$set(this.newItemNo_arr, this.newItemNo_arr.length, temp);
              }
              //处理客户新料号
              if (this.clientNewItemNo_arr.findIndex(item => item.value === items.clientNewItemNo) === -1) {
                var temp = {
                  text: items.clientNewItemNo,
                  value: items.clientNewItemNo
                }
                this.$set(this.clientNewItemNo_arr, this.clientNewItemNo_arr.length, temp);
              }
              //处理旧料号
              if (this.oldMaterialNo_arr.findIndex(item => item.value === items.oldMaterialNo) === -1) {
                var temp = {
                  text: items.oldMaterialNo,
                  value: items.oldMaterialNo
                }
                this.$set(this.oldMaterialNo_arr, this.oldMaterialNo_arr.length, temp);
              }
              //处理订单数量
              if (this.num_arr.findIndex(item => item.value === items.num) === -1) {
                var temp = {
                  text: items.num,
                  value: items.num
                }
                this.$set(this.num_arr, this.num_arr.length, temp);
              }
              //处理需求到货日期
              if (this.arrival_date_arr.findIndex(item => item.value === items.arrival_date) === -1) {
                var temp = {
                  text: items.arrival_date,
                  value: items.arrival_date
                }
                this.$set(this.arrival_date_arr, this.arrival_date_arr.length, temp);
              }
               //处理到货日期
              if (this.arrive_date_arr.findIndex(item => item.value === items.arrive_date) === -1) {
                var temp = {
                  text: items.arrive_date,
                  value: items.arrive_date
                }
                this.$set(this.arrive_date_arr, this.arrive_date_arr.length, temp);
              }
               //处理采购单号
              if (this.purchase_no_arr.findIndex(item => item.value === items.purchase_no) === -1) {
                var temp = {
                  text: items.purchase_no,
                  value: items.purchase_no
                }
                this.$set(this.purchase_no_arr, this.purchase_no_arr.length, temp);
              }
               //处理状态
              if (this.stock_status_arr.findIndex(item => item.value === items.order_status) === -1) {
                var temp = {
                  text: items.order_status,
                  value: items.order_status
                }
                this.$set(this.stock_status_arr, this.stock_status_arr.length, temp);
              }
               //处理交货地
              if (this.delivery_cycle_address_arr.findIndex(item => item.value === items.delivery_cycle_address) === -1) {
                var temp = {
                  text: items.delivery_cycle_address,
                  value: items.delivery_cycle_address
                }
                this.$set(this.delivery_cycle_address_arr, this.delivery_cycle_address_arr.length, temp);
              }
               //处理直发运单号
              if (this.direct_no_arr.findIndex(item => item.value === items.direct_no) === -1) {
                var temp = {
                  text: items.direct_no,
                  value: items.direct_no
                }
                this.$set(this.direct_no_arr, this.direct_no_arr.length, temp);
              }
            })
            
           
          }else {
            this.tableData = [];
            this.$message(response.data.message);
          }
          
        })
        .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style>
.cell {
  text-align: center;
}
.el-table__row {
  background-image: url("../assets/table_logo.png");
}
</style>
<style scoped>
.inputs {
  width: 180px;
  margin-bottom: 10px;
}
.all_part {
  min-width: 1920px;
  min-height: 925px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: row;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 10px 0;
  align-items: center;
}

.table {
  height: 70%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
}

.all_input_top div {
  margin-left: 10px;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  padding: 0 20px;

  display: flex;
  flex-direction: row;
}

.all_second_button {
  display: flex;
  flex-direction: row;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.block {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  align-items: center;
  height: 50px;
}
.all_Kong {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 20px;
}
.sousuoButton {
  position: relative;
}
.icon_sou {
  top: 16px;
  left: 32px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 12px;
  position: absolute;
}
.ShouQi {
  position: relative;
}
.icon_Shou {
  top: 14px;
  left: 12px;

  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}
.Fanhu {
  position: relative;
}

.export-excel-wrapper {
  text-align: center;
}
</style>